// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#footer {
    font-size: 14px;
}

img.navbar-brand.pe-3.ps-4.ps-lg-2 {
    width: 200px;
}

.navbar {
    padding: 0.5rem 1rem;
}

.apnapolicyMenuButton {
    cursor: pointer;
    margin: -4px 30px 0px 0;
}

.offcanvas-header {
    border-bottom: 1px solid #f1f2f3;
}

.logoskybluecolor {
    color: #3ca8e8;
    margin-bottom: 20px;
    position: relative;
}

.mainPolicyHeading{
    position: relative;
    padding: 20px 0px;
}

h3.logoskybluecolor:before {
    content: "";
    position: absolute;
    top: 35px;
    height: 5px;
    width: 55px;
    background-color: #25335b;
}

h3.logoskybluecolor:after {
    content: "";
    position: absolute;
    left: 15px;
    top: 37px;
    height: 1px;
    width: 95%;
    max-width: 255px;
    background-color: #25335b;
}

.mainPolicyHeading h4:before {
    content: "";
    position: absolute;
    top: 48px;
    height: 5px;
    width: 55px;
    background-color: #25335b;
}

.mainPolicyHeading h4:after {
    content: "";
    position: absolute;
    left: 15px;
    top: 50px;
    height: 1px;
    width: 95%;
    max-width: 255px;
    background-color: #25335b;
}

.panel-thumbnail .img-fluid {
    max-width: 80%;
    height: auto;
}


/* contact us styles open */


.thm-container {
    width: 100%;
    max-width: 1200px;
    padding-left: 15px;
    padding-right: 15px;
    margin-left: auto;
    margin-right: auto;
    display: block;
}

.contact-form-content {
    background: #F5F6FA;
    padding: 59px;
}

.thm-container .title {
    margin-bottom: 50px;
}

.thm-container .title span {
    font-family: 'Rubik', sans-serif;
    font-size: 20px;
    color: #FF4328;
}

.thm-container .title h2 {
    color: #212121;
    font-size: 60px;
    line-height: 60px;
    font-weight: bold;
}

.contact-form input,
.contact-form textarea {
    border: none;
    outline: none;
    width: 100%;
    height: 40px;
    background: #fff;
    color: #757575;
    font-size: 16px;
    padding-left: 50px;
    margin-bottom: 10px;
    display: block;
}

.contact-form textarea {
    height: 182px;
    padding-top: 20px;
}

.thm-btn {
    border: none;
    outline: none;
    display: inline-block;
    vertical-align: middle;
    background: #25335b;
    color: #fff;
    font-weight: 500;
    font-size: 16px;
    padding: 18px 69px;
    transition: all .4s;
}

.thm-btn:hover{
    background-color: #3ca8e8;
    border-color:#3ca8e8;
}

.contact-info {
    margin-left: -30px;
    border: 2px solid #EBEDF4;
    padding-top: 75px;
    padding-bottom: 80px;
}

.single-contact-info h4 {
    color: #212121;
    font-size: 18px;
    font-weight: 500;
    margin-bottom: 10px;
}

.contact-info .social a {
    width: 50px;
    height: 50px;
    border-radius: 50%;
    color: #fff;
    font-size: 18px;
    line-height: 59px;
    text-align: center;
    line-height: 50px;
    margin-top: 10px;
    display: inline-block;
    font-family: FontAwesome;
    margin: 5px;
}

.contact-info .social a.fa-twitter {
    background: #1DA1F2;
}

.contact-info .social a.fa-instagram {
    background: #833AB4;
}

.contact-info .social a.fa-facebook-f {
    background: #2884C6;
}

.contact-info .social a.fa-google-plus {
    background: #db4a39;
}

.contact-info .social a.fa-linkedin {
    background: #0077b5;
}



/* contact is styles closed */


label.control-label.removelabel.form-label {
    visibility: hidden;
}

.actionBtn .btn {
    margin-right: 5px;
}

table#tab_logic .form-group {
    margin-bottom: 0px;
}

.getQuotationSideImg img {
    padding-top: 15px;
}

.actionTDBtn .btn {
    margin-right: 5px;
}

.btn,
.form-control {
    border-radius: 0px;
}

table#tab_logic {
    text-transform: capitalize;
}

.comparePolicyScreenTopHeading .form-group {
    margin-bottom: 0px;
}

.policyEditsection {
    line-height: 38px;
}

.policyEditicon {
    padding-left: 20px;
    color: #fff;
}

.policyEditicon:hover {
    padding-left: 20px;
    color: #cdc5c5;
}

.bgColorContainer {
    background-color: #fff;
    padding-top: 20px;
    padding-bottom: 20px;
}

.compareDetailssectionleftBG {
    background-color: #ededed;
    padding: 10px 0px;
    margin-bottom: 5px;
}

.compareDetailssectionleftbox.row {
    align-items: center;
    border-bottom: 1px solid #ededed;
}

.compareDetailssectionleftbox.row:last-child {
    border-bottom: 0px solid #ededed;
}

.tableListNumber {
    line-height: 38px;
    text-align: center;
    font-size: 18px;
}

.compareDetailssection {
    padding: 0;
}

.compareMainDiv .row div {
    border-bottom: 0px;
}

.compareMainDiv .row:last-child div {
    border-bottom: 1px solid #e1e1e1;
}
h6.policyNames{
    font-size: 14px;
    padding-top: 10px;
}

.btn-success {
    color: #fff;
    background-color: #44986f;
    border-color:  #44986f;
}
.comparePolicyScreenTopHeading a{
    color:#fff;
}

.policyIconBG a{
    color:transparent;
}`, "",{"version":3,"sources":["webpack://./src/HeaderComponent/commonstyle.css"],"names":[],"mappings":"AAAA;IACI,eAAe;AACnB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,eAAe;IACf,uBAAuB;AAC3B;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,cAAc;IACd,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,WAAW;IACX,UAAU;IACV,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,WAAW;IACX,UAAU;IACV,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,YAAY;AAChB;;;AAGA,2BAA2B;;;AAG3B;IACI,WAAW;IACX,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gCAAgC;IAChC,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;;IAEI,YAAY;IACZ,aAAa;IACb,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,qBAAqB;IACrB,sBAAsB;IACtB,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAElB,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,qBAAqB;IACrB,wBAAwB;IACxB,WAAW;AACf;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;;;AAIA,6BAA6B;;;AAG7B;IACI,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;;IAEI,kBAAkB;AACtB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,sBAAsB;IACtB,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,yBAAyB;IACzB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,gCAAgC;AACpC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,gCAAgC;AACpC;AACA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,sBAAsB;AAC1B;AACA;IACI,UAAU;AACd;;AAEA;IACI,iBAAiB;AACrB","sourcesContent":["#footer {\r\n    font-size: 14px;\r\n}\r\n\r\nimg.navbar-brand.pe-3.ps-4.ps-lg-2 {\r\n    width: 200px;\r\n}\r\n\r\n.navbar {\r\n    padding: 0.5rem 1rem;\r\n}\r\n\r\n.apnapolicyMenuButton {\r\n    cursor: pointer;\r\n    margin: -4px 30px 0px 0;\r\n}\r\n\r\n.offcanvas-header {\r\n    border-bottom: 1px solid #f1f2f3;\r\n}\r\n\r\n.logoskybluecolor {\r\n    color: #3ca8e8;\r\n    margin-bottom: 20px;\r\n    position: relative;\r\n}\r\n\r\n.mainPolicyHeading{\r\n    position: relative;\r\n    padding: 20px 0px;\r\n}\r\n\r\nh3.logoskybluecolor:before {\r\n    content: \"\";\r\n    position: absolute;\r\n    top: 35px;\r\n    height: 5px;\r\n    width: 55px;\r\n    background-color: #25335b;\r\n}\r\n\r\nh3.logoskybluecolor:after {\r\n    content: \"\";\r\n    position: absolute;\r\n    left: 15px;\r\n    top: 37px;\r\n    height: 1px;\r\n    width: 95%;\r\n    max-width: 255px;\r\n    background-color: #25335b;\r\n}\r\n\r\n.mainPolicyHeading h4:before {\r\n    content: \"\";\r\n    position: absolute;\r\n    top: 48px;\r\n    height: 5px;\r\n    width: 55px;\r\n    background-color: #25335b;\r\n}\r\n\r\n.mainPolicyHeading h4:after {\r\n    content: \"\";\r\n    position: absolute;\r\n    left: 15px;\r\n    top: 50px;\r\n    height: 1px;\r\n    width: 95%;\r\n    max-width: 255px;\r\n    background-color: #25335b;\r\n}\r\n\r\n.panel-thumbnail .img-fluid {\r\n    max-width: 80%;\r\n    height: auto;\r\n}\r\n\r\n\r\n/* contact us styles open */\r\n\r\n\r\n.thm-container {\r\n    width: 100%;\r\n    max-width: 1200px;\r\n    padding-left: 15px;\r\n    padding-right: 15px;\r\n    margin-left: auto;\r\n    margin-right: auto;\r\n    display: block;\r\n}\r\n\r\n.contact-form-content {\r\n    background: #F5F6FA;\r\n    padding: 59px;\r\n}\r\n\r\n.thm-container .title {\r\n    margin-bottom: 50px;\r\n}\r\n\r\n.thm-container .title span {\r\n    font-family: 'Rubik', sans-serif;\r\n    font-size: 20px;\r\n    color: #FF4328;\r\n}\r\n\r\n.thm-container .title h2 {\r\n    color: #212121;\r\n    font-size: 60px;\r\n    line-height: 60px;\r\n    font-weight: bold;\r\n}\r\n\r\n.contact-form input,\r\n.contact-form textarea {\r\n    border: none;\r\n    outline: none;\r\n    width: 100%;\r\n    height: 40px;\r\n    background: #fff;\r\n    color: #757575;\r\n    font-size: 16px;\r\n    padding-left: 50px;\r\n    margin-bottom: 10px;\r\n    display: block;\r\n}\r\n\r\n.contact-form textarea {\r\n    height: 182px;\r\n    padding-top: 20px;\r\n}\r\n\r\n.thm-btn {\r\n    border: none;\r\n    outline: none;\r\n    display: inline-block;\r\n    vertical-align: middle;\r\n    background: #25335b;\r\n    color: #fff;\r\n    font-weight: 500;\r\n    font-size: 16px;\r\n    padding: 18px 69px;\r\n    -webkit-transition: all .4s;\r\n    transition: all .4s;\r\n}\r\n\r\n.thm-btn:hover{\r\n    background-color: #3ca8e8;\r\n    border-color:#3ca8e8;\r\n}\r\n\r\n.contact-info {\r\n    margin-left: -30px;\r\n    border: 2px solid #EBEDF4;\r\n    padding-top: 75px;\r\n    padding-bottom: 80px;\r\n}\r\n\r\n.single-contact-info h4 {\r\n    color: #212121;\r\n    font-size: 18px;\r\n    font-weight: 500;\r\n    margin-bottom: 10px;\r\n}\r\n\r\n.contact-info .social a {\r\n    width: 50px;\r\n    height: 50px;\r\n    border-radius: 50%;\r\n    color: #fff;\r\n    font-size: 18px;\r\n    line-height: 59px;\r\n    text-align: center;\r\n    line-height: 50px;\r\n    margin-top: 10px;\r\n    display: inline-block;\r\n    font-family: FontAwesome;\r\n    margin: 5px;\r\n}\r\n\r\n.contact-info .social a.fa-twitter {\r\n    background: #1DA1F2;\r\n}\r\n\r\n.contact-info .social a.fa-instagram {\r\n    background: #833AB4;\r\n}\r\n\r\n.contact-info .social a.fa-facebook-f {\r\n    background: #2884C6;\r\n}\r\n\r\n.contact-info .social a.fa-google-plus {\r\n    background: #db4a39;\r\n}\r\n\r\n.contact-info .social a.fa-linkedin {\r\n    background: #0077b5;\r\n}\r\n\r\n\r\n\r\n/* contact is styles closed */\r\n\r\n\r\nlabel.control-label.removelabel.form-label {\r\n    visibility: hidden;\r\n}\r\n\r\n.actionBtn .btn {\r\n    margin-right: 5px;\r\n}\r\n\r\ntable#tab_logic .form-group {\r\n    margin-bottom: 0px;\r\n}\r\n\r\n.getQuotationSideImg img {\r\n    padding-top: 15px;\r\n}\r\n\r\n.actionTDBtn .btn {\r\n    margin-right: 5px;\r\n}\r\n\r\n.btn,\r\n.form-control {\r\n    border-radius: 0px;\r\n}\r\n\r\ntable#tab_logic {\r\n    text-transform: capitalize;\r\n}\r\n\r\n.comparePolicyScreenTopHeading .form-group {\r\n    margin-bottom: 0px;\r\n}\r\n\r\n.policyEditsection {\r\n    line-height: 38px;\r\n}\r\n\r\n.policyEditicon {\r\n    padding-left: 20px;\r\n    color: #fff;\r\n}\r\n\r\n.policyEditicon:hover {\r\n    padding-left: 20px;\r\n    color: #cdc5c5;\r\n}\r\n\r\n.bgColorContainer {\r\n    background-color: #fff;\r\n    padding-top: 20px;\r\n    padding-bottom: 20px;\r\n}\r\n\r\n.compareDetailssectionleftBG {\r\n    background-color: #ededed;\r\n    padding: 10px 0px;\r\n    margin-bottom: 5px;\r\n}\r\n\r\n.compareDetailssectionleftbox.row {\r\n    align-items: center;\r\n    border-bottom: 1px solid #ededed;\r\n}\r\n\r\n.compareDetailssectionleftbox.row:last-child {\r\n    border-bottom: 0px solid #ededed;\r\n}\r\n\r\n.tableListNumber {\r\n    line-height: 38px;\r\n    text-align: center;\r\n    font-size: 18px;\r\n}\r\n\r\n.compareDetailssection {\r\n    padding: 0;\r\n}\r\n\r\n.compareMainDiv .row div {\r\n    border-bottom: 0px;\r\n}\r\n\r\n.compareMainDiv .row:last-child div {\r\n    border-bottom: 1px solid #e1e1e1;\r\n}\r\nh6.policyNames{\r\n    font-size: 14px;\r\n    padding-top: 10px;\r\n}\r\n\r\n.btn-success {\r\n    color: #fff;\r\n    background-color: #44986f;\r\n    border-color:  #44986f;\r\n}\r\n.comparePolicyScreenTopHeading a{\r\n    color:#fff;\r\n}\r\n\r\n.policyIconBG a{\r\n    color:transparent;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
